import { ActionTree } from 'vuex';
import axios from 'axios';
import { DigitalState, Digital, RootState } from './digital-types';

export const actions: ActionTree<DigitalState, RootState> = {
  async getDigital({ commit }): Promise<any> {
    await axios({ url: 'https://vb0bti0a28.execute-api.ap-south-1.amazonaws.com/poc/mdm-svc/get-digital' }).then(
      (response) => {
        const payload: Digital = response && response.data;
        commit('setDigitalInState', payload);
      },
      (error) => {
        console.log(error);
        commit('profileError');
      },
    );
  },
};
